import { render, staticRenderFns } from "./EditSavedSearch.vue?vue&type=template&id=40b4f598&scoped=true"
import script from "./EditSavedSearch.vue?vue&type=script&lang=js"
export * from "./EditSavedSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b4f598",
  null
  
)

export default component.exports